import React, { useContext } from 'react';

import { CardContext, ICardContext } from 'context/cardContext';
import './CardMatchStartTime.scss';

//Used to remove any prefixes for the team code before display
const formatParticipantForDisplay = (participantCode: string = '') => {
  const envRegion = process.env.REACT_APP_REGION;
  if (envRegion === 'bg') {
    return participantCode;
  }
  return participantCode.length > 3 ? participantCode.slice(-3) : participantCode;
};

const CardMatchStartTime = () => {
  const { participantCodeOne, participantCodeTwo, formattedMatchStartTime } = useContext<ICardContext>(CardContext);

  return (
    <div className="card-match-start">
      <span className="card-match-start__team">{formatParticipantForDisplay(participantCodeOne)}</span> vs{' '}
      <span className="card-match-start__team">{formatParticipantForDisplay(participantCodeTwo)}</span>
      <div className="card-match-start__time">{formattedMatchStartTime}</div>
    </div>
  );
};

export default CardMatchStartTime;
